// extracted by mini-css-extract-plugin
export default {"infoBox":"InfoBlueBox_infoBox__2-Oue"};